import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { InterfaceElement } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { HTMLTree } from '../../model/html/html-elements/custom-html-elements/html-tree';
import { InterfaceElementTypes } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { TREE_ACTIONS, KEYS, IActionMapping, ITreeOptions, TreeModel, TreeNode, IActionHandler } from '@circlon/angular-tree-component';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { CosyCommunicationControllerService, SearchOption } from 'src/app/service/controller/cosy-communication-controller.service';
import { Subscription } from 'rxjs';
import { TreeRequest } from 'src/app/model/useraction/useractions';
import { TreeUseractions } from 'src/app/model/useraction/task-useraction/tree-useractions';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-cosy-tree',
  templateUrl: './cosy-tree.component.html',
  styleUrls: ['./cosy-tree.component.css']
})
export class CosyTreeComponent implements OnInit {
  private subscriptionTreeUA: Subscription;
  private id: string;
  private groupID: string;
  private siblingsOfSelectedNode: any[] = [];
  private parentNode;

  constructor(
    private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private cdr: ChangeDetectorRef) {
    this.subscriptionTreeUA = this.uxControllerService.executeTreeUA.subscribe(
      (treeAction) => this.fetchUserAction(treeAction.ua, treeAction.value)
    );

  }

  @ViewChild('tree') tree;

  @Input() ie: InterfaceElement = new InterfaceElement();
  @Output() onNodeDrag: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectNode: EventEmitter<any> = new EventEmitter<any>();

  // public treeModelData : TreeModel ;
  public treeModels: any = [{}];

  options: ITreeOptions = {
    displayField: 'name',
    isExpandedField: 'expanded',
    idField: 'id',
    hasChildrenField: 'nodes',
    allowDrag: true,
    allowDrop: (element, { parent, index }) => {
      return true;
    },
    actionMapping: {
      mouse: {
        click: (tree, node, $event) => {
          if (node.data.parentId != null) {
            this.id = node.data.id;
            this.tree.treeModel.getNodeById(this.id).setIsActive(true);
            console.log('TreeNodeID: ' + node.data.id);
            this.siblingsOfSelectedNode = node.parent.data.children;
            this.parentNode = node.parent;
            this.uxControllerService.setActiveSelectedRows(null, [node.data.objectId], [node.data.name]);
            if (this.ie.TypeDID == InterfaceElementTypes.CollectionTree) {
              let so: SearchOption = new SearchOption();
              so.searchString = '~colltree:' + this.id + '~';
              so.ID = node.data.objectId;
              so.treeID = node.data.id;
              so.displayName = node.data.name;
              so.type = 'Collections';
              this.uxControllerService.fetchCollTreeSearch(so)
            }
            else this.uxControllerService.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, this.ie,
              node.data.objectId, null, null, null, new FormGroup({}), false);
          }
        },
        drop: (tree: TreeModel, node: TreeNode, $event: any, { from, to }) => {
          TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });
          this.cosyCommunicationControllerService.setDragnDropInTree(
            this.cosyCommunicationControllerService.localSessionID,
            tree['nodes'][0]['id'],
            from['data']['id'],
            to['parent']['data']['id'],
            to['index']
          ).subscribe(
            response => { },
            error => console.log(error),
            () => { console.log('Drop is done successfully') }
          );
        }
      },
      keys: {
        [KEYS.ENTER]: (tree, node, $event) => {
          node.expandAll();
        }
      }
    },
    nodeHeight: 30,
    allowDragoverStyling: true,
    levelPadding: 10,
    useVirtualScroll: false,
    animateExpand: false,
    scrollOnActivate: true,
    animateSpeed: 30,
    animateAcceleration: 1.2,
    scrollContainer: document.documentElement // HTML
  }

  ngOnInit() {
    if (this.ie != null) {
      let treeRequest: TreeRequest = new TreeRequest();
      treeRequest.cosyToken = this.uxControllerService.sessionID;
      if (this.ie.Values.length > 0 && this.ie.Values[0].Value != null) {
        treeRequest.groupID = this.ie.Values[0].Value;
        this.groupID = this.ie.Values[0].Value;
      }
      this.cosyCommunicationControllerService.executeTree(TreeUseractions.GetTree, treeRequest).subscribe(
        treeData => this.createTree(treeData),
        error => console.log(error),
        () => this.finalizeTree(TreeUseractions.GetTree)
      );
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.subscriptionTreeUA.unsubscribe();
  }

  fetchUserAction(ua: string, value: string) {
    let treeRequest: TreeRequest = new TreeRequest();
    if (ua == 'dededede-55fa-4b61-b4a0-92c8074fb627') {
      treeRequest.cosyToken = this.uxControllerService.sessionID;
      treeRequest.groupID = value;
      this.groupID = value;
    }
    else {
      treeRequest.cosyToken = this.uxControllerService.sessionID;
      treeRequest.groupID = this.groupID;
      treeRequest.entityID = this.ie.ObjectID;
      treeRequest.entityItemID = this.uxControllerService.activeSelectedRowID[0];
      treeRequest.id = this.id;
      treeRequest.name = this.uxControllerService.activeSelectedRowDisplayName[0];
    }
    this.cosyCommunicationControllerService.executeTree(ua, treeRequest).subscribe(

      treeData => this.createTree(treeData),
      error => console.log(error),
      () => {
        this.finalizeTree(ua);
      }
    );
  }

  createTree(treeData: any) {

    let treeModelData;
    let treeModels = [];
    treeData['tree'].forEach(treeItem => {
      if (treeItem.TreeItemFatherID == null || treeItem.TreeItemFatherID == '') {
        treeModelData = {
          name: '', id: '', order: -1, treeId: '', objectId: '', children: []
        };
        treeModelData.name = treeItem.TreeItemText;
        treeModelData.id = treeItem.ID;
        treeModelData.order = treeItem.TreeOrderNumber;
        treeModelData.treeId = treeItem.TreeGroupID;
        treeModelData.objectId = treeItem.TreeItemEntityItemID;
        treeModels.push(treeModelData);
      }
      else {
        let childTreeNode = { name: '', id: '', order: -1, treeId: '', objectId: '', parentId: '' };
        for (let tree of treeModels) {
          if (tree.treeId == treeItem.TreeGroupID) {
            childTreeNode.name = treeItem.TreeItemText;
            childTreeNode.id = treeItem.ID;
            childTreeNode.order = treeItem.TreeOrderNumber;
            childTreeNode.treeId = treeItem.TreeGroupID;
            childTreeNode.objectId = treeItem.TreeItemEntityItemID;
            childTreeNode.parentId = treeItem.TreeItemFatherID;
            let parentOfTreeNode = this.findParentForTreeData(tree, childTreeNode.parentId);
            this.setChildrenForTreeData(parentOfTreeNode, childTreeNode);

          }
        }
      }
    });
    this.treeModels = treeModels;
  }

  finalizeTree(ua: string) {
    setTimeout(() => {
      //this.tree.treeModel.expandAll();
      if (this.tree.treeModel.nodes.length > 0) this.tree.treeModel.getFirstRoot().expand();
      setTimeout(() => {
        if (this.ie.TypeDID == InterfaceElementTypes.CollectionTree) this.id = this.cosyCommunicationControllerService.searchOption.find(colltree => colltree.type == 'Collections') ? this.cosyCommunicationControllerService.searchOption.find(colltree => colltree.type == 'Collections').treeID : null;
        if (this.id != null) {
          if (this.siblingsOfSelectedNode.length == 1 && (ua == TreeUseractions.ItemRemove || ua == TreeUseractions.TreeRemove)) {
            this.tree.treeModel.setExpandedNode(this.parentNode, false)
          }
          this.tree.treeModel.update();
          let node = this.tree.treeModel.getNodeById(this.id);
          if (node != null) {
            node.setIsActive(true);
            if (node.parent != null) node.parent.expand(); 
          }
        }
      }, 100);
    }, 100);
  }

  findParentForTreeData(o, id) {
    if (o.id === id) {
      return o;
    }
    var result, p;
    for (p in o) {
      if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
        result = this.findParentForTreeData(o[p], id);
        if (result) {
          return result;
        }
      }
    }
    return result;
  }

  setChildrenForTreeData(obj, childobj) {
    if (obj['id'] === childobj['parentId']) {
      if (obj.hasOwnProperty('children')) {
        obj.children.push(childobj);
      } else {
        obj['children'] = [];
        obj.children.push(childobj);

      }
      obj.children.sort((a, b) => a.order - b.order);
    }
  }
}
